// @flow

import type {BiePluginType} from '../types';
import {CanvasManager} from '../managers/canvas-manager';

export class BieRotatePlugin implements BiePluginType {
  setup() {}

  getActionButtons() {
    return [
      {
        type: 'immediate-action',
        title: 'Rotate',
        icon: 'fas fa-sync-alt',
        slug: 'rotate',
        cb: this.rotate,
      },
    ];
  }

  rotate(cm: CanvasManager) {
    const activeObject = cm.selectAll();

    if (activeObject != null) {
      activeObject.rotate(90);
      activeObject.set({left: activeObject.height, top: 0});
      activeObject.setCoords();
      cm.canvas.discardActiveObject();
      cm.saveState();
    }
  }
}
